import { render, staticRenderFns } from "./image-modal-item.vue?vue&type=template&id=1a460206&"
import script from "./image-modal-item.vue?vue&type=script&lang=js&"
export * from "./image-modal-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports